import { Types } from "../actions/OrderFormActions";

const initialState = {
    assemblyResponsiblesList: {},
    serviceOrderList: [],
    error: [],
};

export const OrderFormReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_ASSEMBLYRESPONSIBLES:
            return {
                ...state,
                assemblyResponsiblesList: action.payload || state.assemblyResponsiblesList,
            };
        case Types.SET_SERVICEORDER:
            return {
                ...state,
                serviceOrderList: action.payload || state.serviceOrderList,
            };
        case Types.SET_SERVICEORDER_PLANNED:
            return {
                ...state,
                serviceOrderList: action.payload || state.serviceOrderList,
            };
        case Types.SHOW_SNACK_MESSAGE:
            return {
                ...state,
                error: action.payload,
            };
        default:
            return state;
    }
};
